import {useShopActions} from '../../internal/useShopActions'
import {ShopActions} from '../../types'

interface UseErrorToastReturns {
  /**
   * Show an error toast with the given error message.
   */
  showErrorToast: ShopActions['showErrorToast']
}

export const useErrorToast = (): UseErrorToastReturns => {
  const {showErrorToast} = useShopActions()

  return {showErrorToast}
}
